import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    toastContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      borderRadius: '8px',
      border: '1px solid #313131',
      background: '#313131',
      boxShadow: '0 4px 11px 2px rgba(0, 0, 0, 0.25)',
      padding: '8px 14px 8px 18px',
      boxSizing: 'border-box',
    },
    toastMessage: {
      color: '#FFF',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 1.4,
      flex: 1,
      paddingRight: '12px',
      minWidth: 0,
    },
    closeButton: {
      display: 'flex',
      width: '24px',
      height: '24px',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      cursor: 'pointer',
      borderRadius: '6px',
      minWidth: '24px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
    },
    closeIcon: {
      width: '7px',
      height: '7px',
      cursor: 'pointer',
      color: '#FFF',
    },
  }),
  { name: 'Toast' },
);

export default useStyles;
